import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { TruckerActivity } from "./TruckerActivity.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Dock' // optionnel car par defaut utilise le nom de classe
})
export class Dock extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.FilterColumn, IPropretyAttribute.SortColumn] })
  @Validation({ maxLength: 50 },)
  iD_SP!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required,  IPropretyAttribute.SortColumn] })
  status: number = 0;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  fK_CurrentTrucker?: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: TruckerActivity })
  CurrentActivity?: TruckerActivity;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  GetType(): IEntityMetaData {
    return Dock.getMetaData();
  }
}
